import { getSearchAppsApi_v4 } from '@/apis/apps'
import { searchResultsTransformer } from './index'

export const getSearchResultTransformer = async (query, config = {}) => {
  const result = await getSearchAppsApi_v4(query, config)
  return searchResultsTransformer(result)
}
